import { EltType } from 'legacy/lut/classes/models/partner360/ELT/EltType'
import { IELTPopulatedData } from 'legacy/lut/classes/models/partner360/ELT/IELTPopulatedData'
import { appGetState } from 'legacy/lut/store'

import { getTokens } from 'core-components/sitebuilder/helpers/getTokens'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'

export const fetchELTPopulatedData = async ({
  partnerId,
  groupId,
  fYear,
  eltType,
}: {
  partnerId?: string
  groupId?: number | null
  fYear: number
  eltType: EltType
}) => {
  const url = proxy(`/webservice/197/sp/v4/spJBPELTDataToPopulate/call`)

  const {
    app: { ownerId },
  } = appGetState()
  const [accessToken] = getTokens(ownerId)

  if (!partnerId && !groupId) return null

  const payload = {
    'p.PartnerId': partnerId,
    'p.GroupId': groupId,
    'p.FYear': fYear,
    // 'p.EltType': eltType,
  }

  const headers = new HttpHeaders()
  if (accessToken) {
    headers.add('Authorization', `Bearer ${accessToken}`)
  }

  try {
    const response = await Rest.post({ url, payload, headers })
    return (response?.Data?.[0] as IELTPopulatedData) || null
  } catch (e) {
    return null
  }
}
